import clsx from 'clsx';
import React from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../../actions/useAction';
import { useLocalStorage } from '@uidotdev/usehooks';
import { LoginResponseData } from '@EHSNavigator/backend';
import LogoutIcon from '../../assets/icons/log-out.svg?react';
import Button from '../Button';

interface OrgnizationPlanExpireProps {
  otherClasses?: string;
}

const OrgnizationPlanExpire: React.FC<OrgnizationPlanExpireProps> = ({
  otherClasses,
}) => {
  const orgnizationPlanExpireClasses = clsx(
    otherClasses,
    'w-full relative min-h-dvh flex items-center justify-center bg-black px-4',
  );
  const dispatch = useDispatch();
  const [, setUserInfo] = useLocalStorage<LoginResponseData | null>(
    'userInfo',
    null,
  );
  const handleLogout = async () => {
    await dispatch(logout(setUserInfo) as any);
  };
  return (
    <div
      className={orgnizationPlanExpireClasses}
      data-testid="orgnization-plan-expire"
    >
      <img
        src="/assets/images/background-image.png"
        alt="plan-expired"
        className="absolute top-0 left-0 hidden h-full w-full object-fill opacity-80 blur-xs md:block"
      />
      <img
        src="/assets/images/background-mobile-image.png"
        alt="plan-expired"
        className="absolute top-0 left-0 h-full w-full object-fill opacity-80 blur-xs md:hidden"
      />
      <div className="bg-translucent-background shadow-pricing-plans-card relative my-auto h-auto w-full max-w-573 overflow-auto rounded-2xl p-5 lg:px-9 lg:py-6">
        <img
          src="/assets/images/logo.png"
          alt="logo"
          className="mx-auto mb-6 h-85 w-69 md:h-100 md:w-20"
        />
        <h4 className="mb-4 text-center">
          Your <span className="text-brand-byzantine">Organization</span> Plan
          Has <span className="text-brand-posh-pink">Expired</span>
        </h4>
        <p className="font-inter-variable text-center text-lg font-normal">
          Please contact your administrator regarding the subscription to
          continue enjoying our services.
        </p>

        <Button
          variant="secondary"
          otherClasses="mt-15 w-full  hover:border-brand-posh-pink  hover:text-brand-posh-pink"
          size="smaller"
          onClick={handleLogout}
        >
          <LogoutIcon className="h-5 w-5 [&>path]:fill-current" />
          Logout
        </Button>
      </div>
    </div>
  );
};

export default OrgnizationPlanExpire;
